/*
 *
 * XpayBackOfficePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 10-Apr-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import XpayBackOfficePopup from './XpayBackOfficePopup'
import * as HomepageActions from '../../routes/Homepage/modules/HomepageActions'
import { doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(HomepageActions, dispatch),
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = (state) => ({
  isLoading: nullSafe(() => state.loading.localLoading.get_url_for_xpay, false),
  shops: nullSafe(() => state.Homepage.shops, []),
  terminals: nullSafe(() => state.Homepage.terminals, [])
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(XpayBackOfficePopup)
